module.exports = __webpack_public_path__ + "static/media/google_logo.38401d7f.png";